export default "__VITE_PUBLIC_ASSET__2fb560a2__"